import { useState, useEffect } from 'react';
import axios from 'axios';
import routes from 'app/routes';

export default function useCustomServices(params = '') {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState(null);

  useEffect(() => {
    axios
      .get(`${routes.api.policy_plan_custom_record_templates.index}?${params}`)
      .then((resp) => {
        setLoading(false);
        setServices(resp.data.data);
      });
  }, []);

  return { loading, services };
}
